import {
  EconomyTemplate,
  EconomyTemplateAttributesUpdate,
  EconomyTemplateCreate,
  EconomyTemplateDetail,
  EconomyTemplateList,
  EconomyTemplateUpdate,
} from '../types/economyTemplate';
import { apiClient } from './client';

const BASE_URL = '/economy-templates';

export const economyTemplatesApi = {
  getTemplates: async (params?: {
    skip?: number;
    limit?: number;
    is_public?: boolean;
    include_public?: boolean;
    template_type?: 'field' | 'layer';
    search?: string;
    include_user_names?: boolean;
  }): Promise<EconomyTemplateList> => {
    return apiClient.get<EconomyTemplateList>(`${BASE_URL}/list`, { params });
  },

  getTemplate: async (id: string): Promise<EconomyTemplateDetail> => {
    return apiClient.get<EconomyTemplateDetail>(`${BASE_URL}/${id}`);
  },

  updateTemplateAttributes: async (
    templateId: string,
    data: EconomyTemplateAttributesUpdate,
  ): Promise<EconomyTemplateDetail> => {
    return apiClient.put<EconomyTemplateDetail>(`${BASE_URL}/${templateId}/attributes`, data);
  },

  createTemplate: async (data: EconomyTemplateCreate): Promise<EconomyTemplateDetail> => {
    // Trailing slash required — without it FastAPI 307-redirects to http://backend:8000 (CORS in browser).
    return apiClient.post<EconomyTemplateDetail>(`${BASE_URL}/`, data);
  },

  updateTemplate: async (id: string, data: EconomyTemplateUpdate): Promise<EconomyTemplateDetail> => {
    return apiClient.put<EconomyTemplateDetail>(`${BASE_URL}/${id}`, data);
  },

  deleteTemplate: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },

  copyTemplate: async (id: string): Promise<EconomyTemplate> => {
    return apiClient.post<EconomyTemplate>(`${BASE_URL}/${id}/copy`);
  },

  getAvailableAttributes: async (scope?: 'field' | 'layer'): Promise<
    Array<{
      id: string;
      name: string;
      type: string;
      description?: string;
      scope: string;
    }>
  > => {
    return apiClient.get(`${BASE_URL}/attributes/available`, {
      params: scope ? { scope } : undefined,
    });
  },
};

export const getEconomyTemplates = economyTemplatesApi.getTemplates;
export const getEconomyTemplate = economyTemplatesApi.getTemplate;
export const updateEconomyTemplateAttributes = economyTemplatesApi.updateTemplateAttributes;
export const getAvailableAttributes = economyTemplatesApi.getAvailableAttributes;
export const createEconomyTemplate = economyTemplatesApi.createTemplate;
export const updateEconomyTemplate = economyTemplatesApi.updateTemplate;
export const deleteEconomyTemplate = economyTemplatesApi.deleteTemplate;
export const copyEconomyTemplate = economyTemplatesApi.copyTemplate;
